var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "billing-counter-container" }, [
    _c("div", { staticClass: "billing-counter-title" }, [
      _vm._v(_vm._s(_vm.text[_vm.type])),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "billing-counter" }, [
      _c(
        "div",
        { staticClass: "billing-counter-button", on: { click: _vm.decrement } },
        [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v("\n                remove\n            "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "billing-counter-value" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.counter,
              expression: "counter",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.counter },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.counter = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "billing-counter-button", on: { click: _vm.increment } },
        [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v("\n                add\n            "),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }